const PLATFORMS = [
  { k: "spotify", label: "Spotify", icon: "/assets/icons/spotify.svg" },
  { k: "apple_music", label: "Apple Music", icon: "/assets/icons/applemusic.svg" },
  { k: "youtube", label: "YouTube", icon: "/assets/icons/youtube.svg" },
];

export const StreamingLinks = ({ links = {} }) => (
  <div className="flex items-center gap-2" data-testid="streaming-links">
    <span className="font-mono text-[10px] tracking-[0.25em] text-white/45 mr-2">STREAM</span>
    {PLATFORMS.filter((p) => links[p.k]).map((p) => (
      <a key={p.k} href={links[p.k]} target="_blank" rel="noopener noreferrer" title={p.label} aria-label={p.label}
         className="w-9 h-9 rounded-full border border-white/15 bg-white/5 flex items-center justify-center transition-[transform,background-color,border-color] duration-200 hover:-translate-y-0.5 hover:bg-white/15 hover:border-white/40"
         data-testid={`stream-link-${p.k}`}>
        <img src={p.icon} alt="" className="w-4 h-4" />
      </a>
    ))}
  </div>
);
